export const accounting = {
  writing: {
    fiche: {
      title: {
        edit_title: "Fiche de l'écriture {{libelle}}",
        view_title: "Fiche de l'écriture",
        new_title: "Création d'une nouvelle écriture",
        caracteristic: 'Caractéristiques',
        accounting_caracteristic: 'Caractéristiques Comptabilité',
        reconciliation: 'Rapprochement comptable',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
      },
      champ_titles: {
        account: 'Compte',
        placeholder_account: 'Select le Code compte',
        libelle: 'Libellé',
        operation_date: 'Date Opération',
        writing_number: 'Num. Ecriture',
        category: 'Catégorie',
        state: 'Etat',
        amount: 'Montant',
        writing_type: 'Type Ecriture',
        code_sens: 'Code Sens',
      },
      placeholder: {
        amount: "Montant de l'opération",
        category: 'Saisir le Code Catégorie',
        writing_number: 'Numéro écriture',
      },
    },
    table: {
      header: {
        title: 'Liste des écritures',
        error_selected: 'Erreur',
        txt_error: "Les écritures sélectionnées n'ont pas le même état",
        visualisation: 'Visualisation session ',
      },
      filters: {
        state: '-Etat-',
        scope: '- Scope -',
        title: 'Modification de masse des écritures',
        operationDate: 'Date opération',
        category: '-  Catégorie -',
        title_import: 'Import des écritures',
        selected_file: 'Selectionner les fichiers',
        aucun_file: 'Aucun fichier sélectionner',
      },
      columns: {
        state: 'Etat',
        libelle: 'Libellé',
        montant: 'Montant',
        devise: 'Devise',
        categorie: 'Catégorie',
        operation_date: 'Date opération',
        reference: 'N° écriture',
        account: 'Compte',
        company: 'Société',
        code_sens: 'Sens',
        writing_type: 'Type écriture',
        modif: 'Modification',
        user: 'User',
        opening_balance: 'Solde début',
        ending_balance: 'Solde fin',
        session_entries_id: 'IDSession',
      },
    },
    visu_session: {
      title: 'Liste des sessions',
      columns: {
        id: 'ID',
        account: 'Compte',
        date: 'Date',
        opening_balance: 'Solde début',
        ending_balance: 'Solde fin',
        devise: 'Devise',
        state: 'Etat',
      },
    },
    action: {
      title: 'Action',
      edit_masse: 'Modification masse',
      print: 'Imprimer',
      importer: 'Importer',
    },
  },
  rules: {
    fiche: {
      title: {
        edit_title: 'Fiche de la règle {{code}}',
        view_title: 'Fiche de la règle {{code}}',
        new_title: "Création d'une nouvelle Règle",
        rapprochement_criteria: 'Critères de Rapprochement',
        operation_linked: 'Liste des codes opérations liés',
        members: 'Liste des membres',
        rappro: 'Rapprochement par montant',
        modal_title: 'Liste des sociétés',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        new: 'Nouveau',
        create: 'Créer',
      },
      champ_titles: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        order: 'Ordre',
        category: 'Catégorie',
        mode: 'Mode',
        rapprochement_by_date: 'Rapprochement par date',
        rapprochement_by_label: 'Rapprochement par libellé',
        rapprochement_by_ref: 'Rapprochement par référence',
        date_difference: 'Ecart Date',
        detail_flux: 'Détail flux brouillard',
        placeholder_detail_flux: 'Détail',
        download_model: 'Télécharger modèle excel',
      },
      columns: {
        code: 'Code',
        name: 'Nom',
      },
    },
    table: {
      header: {
        title: 'Liste des règles',
        new_rule: 'Nouveau',
      },
      columns: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        date: 'Date de modification',
        automanuel: 'Auto Manuel',
        order: 'Ordre',
      },
    },
  },
  historique: {
    title: 'Historique de rapprochement',
    show_details: 'Visualisation Détail',
    session_selection: 'Sélection Session',
    deraprochement: 'Dérapprochement Session',
    scope: 'Scope',
    company: 'Société',
    code: 'Saisir le code compte',
    mvt_bancaire: 'Mouvements bancaire rapprochés',
    ecriture_rapprochement: 'Ecritures comptables rapprochées',
    message: 'Voulez-vous renvoyer le lot à la banque ?',
    category: 'Catégorie',
    writing_date: 'Date Ecriture',
    rappro_date: 'Date Rappro',
    columns: {
      account: 'Compte',
      category: 'Cat.',
      date: 'Date Ope.',
      label: 'Libellé',
      amount: 'Montant',
    },
    modal: {
      title: {
        session_list: 'Liste des sessions',
      },
      buttons: {
        visualize: 'Visualiser',
      },
      columns: {
        date_num: 'Date/Num.',
        user: 'User',
        mvt_number: 'Nb Mvts',
        wrt_number: 'Nb Ecr',
        nb_mvt: 'Nb mouvement',
        nb_prevision: 'Nb prévision',
      },
    },
    detail: {
      columns: {
        account: 'Compte',
        amount: 'Montant',
        label: 'Libellé',
        date: 'Date Valeur',
        op_date: 'Date Opé.',
        category: 'Catégorie',
        gap: 'Ecart',
        state: 'Etat',
        sel: 'Sél.',
        referency: 'N° écriture',
      },
      buttons: {
        validate: 'Derapprocher',
        save: 'Valider',
        back: 'Retour',
      },
      titles: {
        general: 'Rapprochement - Detail',
        movement: 'Mouvements bancaires rapprochés',
        detail: 'Rapprochement',
        writing: 'Ecritures comptables rapprochées',
      },
      champ_titles: {
        number: 'Nb',
        movement_total: 'Total Mouvements',
        gap: 'Ecart',
        writtingTotal: 'Total Écritures',
      },
    },
  },
  rapprochement: {
    header: {
      title: 'Rapprochement',
      manuel: 'Regle manuelle',
      montant: 'Montant 1/1',
      montantNN: 'Montant N/N',
      rapprocher: 'Rapprocher',
      comment: 'Commentaires',
      eclatement: 'Eclatement',
      date_cloture: 'Date clôture',
      title_rappro: 'Rapprochement - Détail',
      total_movements: 'Total Mouvements',
      gap: 'Ecart',
      total_entries: 'Total écritures',
      number: 'Nb',
      nodata: 'Pas de données',
      message_validation:
        "Attention tous les comptes n'ont pas la même date de clôture. La plus petite date a été sélectionnée.",
    },
    modal: {
      titles: {
        burst: "Eclatement de l'écriture",
        comment: 'Commentaires du mouvement',
      },
      comment: 'Commentaire',
      new: 'Nouveau',
      total: 'Total Saisie',
      rest: 'Reste a eclaté',
    },
    cards: {
      closed_banking_infos: 'Mouvements bancaires à rapprocher',
      closed_writing: 'Ecritures à rapprocher',
    },
    columns: {
      title: {
        account: 'Compte',
        cat: 'Cat',
        currency: 'Dev.',
        account_id: 'Code Opé.',
        op_date: 'Date Opé.',
        label: 'Libellé',
        date: 'Date',
        hour: 'Heure',
        comment: 'Comentaire',
        referency: 'N° écriture',
        entry_type: 'Type écriture',
        creation_timestamp: 'Date création',
        login: 'Login',
        amount: 'Montant',
        ref: 'Référence',
        direction: 'Sens',
        reconcil_number: 'N piece',
        com: 'Com.',
        company: '- Société -',
        account_code: '- Code Compte -',
        category: '- Categorie -',
        complementary_label: 'Libellé complémentaire',
        group_compte: '- Groupe Compte -',
      },
    },
    footer: {
      total_forecasts: 'Total Ecritures',
    },
    detail: {
      table_mvt: {
        sel: 'Sél.',
        cat: 'Catégorie',
        op_date: 'Date Opé.',
        amount: 'Montant',
        ref: 'Référence',
        dat: 'Date Opé.',
      },
      table_rappro: {
        account: 'Compte',
        diff: 'Ecart',
        state: 'Etat',
      },
    },
  },
  consultation: {
    table: {
      header: {
        title: {
          general: 'Consultation des soldes comptables',
          selecte_date: 'Sélection date',
        },

        champ_titles: {
          scope: 'Scope',
          company: 'Société',
          start_date: 'Date Début',
          end_date: 'Date Fin',
        },
        select: {
          account: '- Compte -',
          company: '- Société -',
          scope: '- Scope -',
        },
      },
      buttons: {
        init: 'Initialiser',
        close: 'Fermer',
        add: 'valider',
        print: 'Imprimer',
        print1: 'Mouvements non rapprochés',
        print2: 'Écriture non rapprochés',
        print3: 'Écritures période',
      },
      columns: {
        history: {
          bank_balance: 'Solde bancaire',
          movement_number: 'Nbs mvts',
          amount: 'Total mouvements non rapprochés',
          number_writing: 'Nb écrit',
          sum_amount: 'Total écriture non rapprochées',
          accounting_balance: 'Solde comptable',
          currency: 'Devise',
          current_date: 'Date Solde en cours',
          imp: 'Etat de clôture',
        },
        table: {
          account_code: 'Code',
          name: 'Nom',
          society_code: 'Société',
          balance_date: 'Date Cloture',
          book_balance: 'Solde Cloture',
          valid_closing_date: 'Dernier Date Cloture validé',
          valid_closing_balance: 'Dernier Solde Cloture validé',
        },
      },
    },
    detail: {
      title: {
        init: 'Initialisation du solde comptable',
        info: 'Sélection des informations de clôture',
        mouvement: 'Sélection des mouvements non rapprochés',
        writing: 'Création des écritures comptables non rapprochés',
        sub_info:
          'Veuillez sélectionner les mouvements bancaires non rapprochés',
        sub_info_writing:
          'Veuillez créer les écritures comptables non rapprochées',
        bank_balance: 'Solde bancaire au {{date}}',
        accounting_balance: 'Solde Comptable au {{date}}',
        validation: "Validation de l'initialisation comptable",
        element_selected:
          'Mouvements bancaires non rapprochés sélectionnés : ( {{nbr}} éléments ) ',
        tooltip: 'Voir les éléments sélectionnés',
      },
      buttons: {
        next: 'Suivant',
        add: 'Ajouter',
        save: 'Valider',
        print: 'Afficher',
      },
      error: {
        date: 'La date d’opération ne doit pas être supérieure à la date choisie',
      },
      columns: {
        category: 'Catégorie',
        date: 'Date Opération',
        label: 'Libellé',
        amount: 'Montant',
        operation_date: 'Date opé.',
        currency: 'Devise',
        modification: 'Modification',
      },
      champ_titles: {
        balance_date: 'Date Solde',
        balance_accounting: 'Solde comptable',
        account: 'Code compte',
        total: 'Total mouvements non rapprochés',
        number: 'Nb',
        total_writing: 'Total écriture non rapprochés',
        operation_date: 'Date Opération',
        label: 'Libellé',
        category: 'Catégorie',
        amount: 'Montant',
        total_movement_not_reconciled: 'Total Mouvements non rapprochés',
        number_movement_not_reconciled: 'Nb de mouvements  non rapprochés',
        total_writing_not_reconciled: 'Total Ecritures non rapprochés',
        number_writing_not_reconciled: "Nb d'écritures non rapprochés",
        difference_balance: 'Ecart avec solde saisie',
      },
    },
  },
  closure: {
    select: {
      account: '- Compte -',
      company: '- Société -',
      scope: '- Scope -',
    },
    table: {
      title: 'Clôture comptable',
      closing: 'Clôturer',
      state: 'Etat',
      code: 'Code',
      bank_balance: 'Solde bancaire',
      operation_number: 'Nb opérations',
      sum_operation_non_reconcil: 'Total mouvements non rapprochés',
      entry_number: 'Nb écritures',
      sum_entry_non_reconcil: 'Total écritures non rapprochées',
      accounting_balance: 'Solde comptable',
      currency: 'Devise',
      current_date: 'Date solde en cours',
      closing_state: 'Etat de clôture',
      modal: {
        title: 'Clôture de compte',
        confirm_closing: 'Voulez-vous clôturer ce(s) compte(s) ?',
        next_date: 'Prochaine date de clôture',
      },
    },
    history: {
      bank_balance: 'Solde Bancaire',
      movement_number: 'Nbs mvts',
      non_reconcil_movement: 'Total mouvements non rapprochés',
      accounting_entries_number: 'Nb écrit',
      non_reconcil_entries: 'Total écritures non rapprochées',
      accounting_balance: 'Solde comptable',
      currency: 'Devise',
      current_balance_date: 'Date Clôture',
      cancel_closing: 'Déclôturer',
      state: 'Etat de cloture',
      confirm_closing:
        'Vous allez annuler cette clôture et revenir à la session de rapprochement précédente. Désirez-vous continuer',
      last_closing: 'Dernière clôture',
      user: 'Utilisateur',
    },

    error: "Les comptes sélectionnées n'ont pas la même date de clôture",
    unselected_error: 'Vous devez sélectionner au moins un compte',
    action: 'Action',
    export_excl: 'Exporter Détails',
    imprime_detail: 'Imprimer détail',
  },
  movement: {
    title: 'Liste des mouvements non rapprochés',
  },
}

